<template>
  <div class="cart-total">
    <div class="cart-total__inner bg-gray rounded-lg">
      <div class="cart-total__row">
        <div class="cart-total__col">
          <div class="flex justify-center items-center text-base">
            <i18n path="common.cart.formatLabel" class="flex items-center">
              <template #label>
                <span>{{ $t('common.cart.subTotal') }}</span>
              </template>
              <template #tax>
                <span class="tax-font">{{ $t('common.cart.withTax') }}</span>
              </template>
            </i18n>
            <el-popover
              class="ml-2"
              :tabindex="2"
              placement="top"
              title=""
              width="200"
              trigger="hover"
              :content="$t('common.cart.subtotalExplanation')"
            >
              <span slot="reference">
                <img :src="require('@/assets/images/help-round-icon.svg')" alt="" />
              </span>
            </el-popover>
          </div>
        </div>
        <div class="cart-total__col text-base">
          <i18n path="common.cart.formatPrice">
            <template #price>
              <span>{{ subTotal.toLocaleString() }}</span>
            </template>
            <template #unit>
              <span class="text-xs">{{ $t('common.cart.yen') }}</span>
            </template>
          </i18n>
        </div>
      </div>
      <div v-if="subDiscount !== 0" class="cart-total__row mt-1">
        <div class="cart-total__col mt-0">
          <i18n path="common.cart.formatLabel">
            <template #label>
              <span class="text-xs font-light">{{ $t('common.cart.discount') }}</span>
            </template>
          </i18n>
        </div>
        <div class="cart-total__col">
          <i18n path="common.cart.formatPriceBracket" class="text-xs text-red">
            <template #price>
              <span class="text-xs">{{ subDiscount.toLocaleString() }}</span>
            </template>
            <template #unit>
              <span class="text-xs">{{ $t('common.cart.yen') }}</span>
            </template>
          </i18n>
        </div>
      </div>
      <div v-if="user && user.rank_name && hasDiscount && user.rank_use_flag" class="cart-total__row mt-1">
        <i18n class="text-xs text-red" path="common.messages.rankDiscount">
          <template #rankMember>
            <span class="text-xs">{{ $t(user.rank_name) }}</span>
          </template>
        </i18n>
      </div>
      <div class="cart-total__row">
        <div class="cart-total__col">
          <i18n path="common.cart.formatLabel" class="flex items-center">
            <template #label>
              <span>{{ $t('common.cart.deliveryFee') }}</span>
            </template>
            <template #tax>
              <span class="tax-font">{{ $t('common.cart.withTax') }}</span>
            </template>
          </i18n>
        </div>
        <div class="cart-total__col">
          <i18n path="common.cart.formatPrice">
            <template #price>
              <span>{{ deliveryFee.toLocaleString() }}</span>
            </template>
            <template #unit>
              <span class="text-xxs">{{ $t('common.cart.yen') }}</span>
            </template>
          </i18n>
        </div>
      </div>
      <div class="cart-total__row is-bold">
        <div class="cart-total__col">
          <i18n path="common.cart.formatLabel" class="flex items-center">
            <template #label>
              <span>{{ $t('common.cart.total') }}</span>
            </template>
            <template #tax>
              <span class="tax-font">{{ $t('common.cart.withTax') }}</span>
            </template>
          </i18n>
        </div>
        <div class="cart-total__col">
          <i18n path="common.cart.formatPrice">
            <template #price>
              <span class="text-2xl">{{ total.toLocaleString() }}</span>
            </template>
            <template #unit>
              <span class="text-xxs">{{ $t('common.cart.yen') }}</span>
            </template>
          </i18n>
        </div>
      </div>
      <div class="cart-total__row">
        <div class="cart-total__col">
          <i18n path="common.cart.formatLabel">
            <template #label>
              <span class="text-xs font-light">{{ $t('common.cart.tax') }}</span>
            </template>
          </i18n>
        </div>
        <div class="cart-total__col">
          <i18n path="common.cart.formatPriceBracket" class="text-xs">
            <template #price>
              <span class="text-xs">{{ tax.toLocaleString() }}</span>
            </template>
            <template #unit>
              <span class="text-xxs">{{ $t('common.cart.yen') }}</span>
            </template>
          </i18n>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    subTotal: {
      type: Number,
      default: 0,
    },
    subDiscount: {
      type: Number,
      default: 0,
    },
    deliveryFee: {
      type: Number,
      default: 0,
    },
    tax: {
      type: Number,
      default: 0,
    },
    total: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    hasDiscount() {
      return this.subDiscount !== null && this.subDiscount !== '' && this.subDiscount !== 0
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/components/cart-total.scss';
</style>
